import {gql} from "@apollo/client";

export const UpdateDashboardConfig = gql`
    mutation UpdateDashboardConfig($input: ProfileUpdateAttributesInput!) {
        updateProfile(input: $input) {
            id
            dashboardConfig
        }
    }
`;
